<template>
  <div class="full-width bg-blue">
    <div class="container">
      <div class="flex justify-center align-center full-width">
        <div class="game-info padding full-width">
          <div class="flex justify-center align-center"><h1>近期赛事</h1></div>

          <el-carousel
            :autoplay="false"
            height="calc(12vw + 180px)"
            arrow="always"
          >
            <el-carousel-item
              v-for="(itemList, index) in gamesList"
              :key="index"
            >
              <div
                class="flex justify-around"
                style="margin-left: 10%; width: 80%; margin-top: 80px;"
              >
                <div
                  v-for="(item, index) in itemList"
                  :key="index"
                  style="margin-left: 2vw"
                >
                  <img
                    style="width: 18vw; height: 12vw;"
                    @click="toGame(item.id)"
                    class="full-width cursor-pointer"
                    :src="item.picture"
                  />
                  <div
                    style="height: 90px;"
                    class="flex flex-direction justify-around padding-bottom-10"
                  >
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="item.title"
                      placement="top-start"
                    >
                      <div
                        class="font-20 text-white text-bold no-wrap-and-ell"
                        style="width: 18vw;"
                      >
                        {{ item.title }}
                      </div>
                    </el-tooltip>

                    <div
                      class="font-14 margin-top-xs text-white text-bold no-wrap-and-ell"
                    >
                      地点: {{ item.address }}
                    </div>
                    <div class="font-14 text-white text-bold no-wrap-and-ell">
                      时间: {{ item.game_start_time }}
                    </div>
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getGamesList } from '@/servers/homepage.js';
import { mapState } from 'vuex';

export default {
  data() {
    return {
      gamesList: [],
      page: 1,
      pages: 1,
      page_size: 18,
      hasNext: false,
      hasPrev: false,
    };
  },

  computed: {
    ...mapState(['UI']),
  },

  created() {
    this.flushData();
  },

  methods: {
    onChange: function(index, newIndex) {
      this.page = newIndex;
      this.flushData();
    },

    flushData: function() {
      let that = this;
      that.gamesList = [];

      getGamesList({ page: this.page, page_size: this.page_size }, function(
        res,
      ) {
        let temp = [];
        for (let index in res.items) {
          if (index > 0 && index % 3 == 0) {
            that.gamesList.push(temp);
            temp = [];
          } else {
            temp.push(res.items[index]);
          }
        }
        if (temp.length > 0) {
          that.gamesList.push(temp);
        }
      });
    },

    toGame: function(gameId) {
      this.$router.push({
        name: 'gameInfo',
        query: { id: gameId },
      });
      // const url = this.$router.resolve({
      //   name: 'gameInfo',
      //   query: { id: gameId },
      // });
      // window.open(url.href, '_blank');
    },
  },
};
</script>

<style lang="scss">
.game-item {
  color: #353535;
}

.left-roll {
  width: 10%;
  font-size: 8vw;
}

.right-roll {
  width: 10%;
  font-size: 8vw;
}

.roll-body {
  width: 80%;
}

.game-info {
  .el-carousel__arrow {
    width: 4vw;
    height: 4vw;
    font-size: 1.5vw;
  }

  .el-carousel__indicators {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/home/games.vue